import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppDetailShellComponent } from './app-detail-shell/app-detail-shell.component';
import { AppNotFoundComponent } from './app-not-found/app-not-found.component';
import { MarketplaceHomePageComponent } from './marketplace-home/marketplace-home.component';
import { CheckAppExistsGuard, SilentAuthGuard } from '@realwear-cloud/app-marketplace/shared';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        redirectTo: 'browse/featured',
        pathMatch: 'full'
      },
      {
        path: 'browse/:category',
        component: MarketplaceHomePageComponent
      },
      {
        path: 'app/:id',
        component: AppDetailShellComponent,
        canActivate: [SilentAuthGuard, CheckAppExistsGuard]
      },
      {
        path: '404',
        component: AppNotFoundComponent
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ])
  ]
})
export class MarketplaceRouting {}
